/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import numericalFieldHandler from "../../../utils/numericalFieldHandler";
import translateLabel from "../../../utils/translateLabel";

interface Props {
  id: string;
  mode: any;
  on: any;
  hasMoreModes: boolean;
  handleChange: any;
  translations: any;
}

const RepeatMonthlyOn = ({
  id,
  mode,
  on,
  hasMoreModes,
  handleChange,
  translations,
}: Props) => {
  const isActive = mode === "on";

  const renderOptions = () => {
    const result = [];

    for (let i = 0; i < 31; i++) {
      result.push(
        <option key={i} value={i + 1}>
          {i + 1}
        </option>
      );
    }

    return result;
  };

  return (
    <div
      className={`form-group row d-flex align-items-sm-center`}
      css={css`
        display: grid !important;
        grid-template-columns: 18px auto 80px !important;
        grid-template-areas: "checkbox text input" !important;
      `}
    >
      <div
        className="col-sm-1 offset-sm-2"
        css={css`
          grid-area: checkbox;
        `}
      >
        {hasMoreModes && (
          <input
            id={id}
            type="radio"
            name="repeat.monthly.mode"
            aria-label="Repeat monthly on"
            value="on"
            onChange={handleChange}
          />
        )}
      </div>

      <div
        className="col-sm-3"
        css={css`
          grid-area: input;
        `}
      >
        <select
          id={`${id}-day`}
          name="repeat.monthly.on.day"
          aria-label="Repeat monthly on a day"
          className="form-control"
          value={on.day}
          onChange={numericalFieldHandler(handleChange)}
        >
          {/* {[...new Array(31)].map((_, i) => (
            <option key={i} value={i + 1}>
              {i + 1}
            </option>
          ))} */}
          {renderOptions()}
        </select>
      </div>
      <div
        className="col-sm-2"
        css={css`
          text-transform: capitalize;
          grid-area: text;
        `}
      >
        {translateLabel(translations, "repeat.monthly.on_day")}
      </div>
    </div>
  );
};

export default RepeatMonthlyOn;
